<template>
  <el-table
    class="custom-table_top"
    border
    size="mini"
    :header-cell-style="{
      background: '#5D99D5',
      color: '#fff',
    }"
    :data="tableData"
    :span-method="mergeCells">
    <el-table-column align="center" label="版本对比">
      <template #default="scope">
        <span>{{ scope.row.curVersion }}</span
        ><span style="margin: 5px">vs</span
        ><span>{{ scope.row.lastVersion }}</span>
      </template>
    </el-table-column>
    <el-table-column align="center" width="100" label="测试场景">
      <template #default="scope">
        <span>{{ scope.row.scene }}</span>
      </template>
    </el-table-column>
    <el-table-column align="center" label="测试画质">
      <template #default="scope">
        <span>{{ scope.row.level }}</span>
      </template>
    </el-table-column>
    <el-table-column align="center" label="纬度">
      <template #default="scope">
        <span>{{ scope.row.dimension }}</span>
      </template>
    </el-table-column>
    <el-table-column
      width="150"
      align="center"
      label="UnreleasedNativeMallocSize内存变化(MB)"
    >
      <template v-slot:header>
        <div>MallocSize</div>
        <div>内存增长值(MB)</div>
      </template>
      <template #default="scope">
        <span>{{ scope.row.diif_new }}</span
        ><span
          :style="'color:' + risk_color(scope.row.memory_diff)[1]"
          >({{ risk_color(scope.row.memory_diff)[0] }})</span
        >
      </template>
    </el-table-column>
    <el-table-column align="center" label="火焰图">
      <template #default="scope">
        <span
          class="download-link"
          @click="downLoadNew(scope.row)"
          >下载</span
        >
      </template>
    </el-table-column>
    <el-table-column
      :show-overflow-tooltip="true"
      width="350"
      label="Top增长函数"
    >
      <template #default="scope">
        <span>{{ scope.row.funcName }}</span>
      </template>
    </el-table-column>
    <el-table-column
      width="180"
      align="center"
      label="增长未释放"
    >
      <template v-slot:header>
        <div>MallocSize</div>
        <div>内存增长值(MB)</div>
      </template>
      <template #default="scope">
        <span>{{ scope.row.diff }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import {
  getLocalProject,
  grAxios,
} from "@/utils";

const store = {}

export default {
  props: {
    tableData: Array,
    tableType: String,
    xcodeReportData: Object,
  },

  data() {
    return {
      localProject: Number(getLocalProject()), //得到本地的项目
    }
  },

  methods: {
    dispatchXcodeFileName(store, params) {
      return grAxios({
        url: `/xcode/filename/`,
        params,
      })
    },

    dispatchPerfettoDownLoadDimensionStack(store, params) {
      return grAxios({
        url: `/xcode/stack_download/`,
        params,
        responseType: 'blob'
      })
    },

    downLoadNew(data) {
      let functionData = this.xcodeReportData.risk_funcs;
      let soData = this.xcodeReportData.risk_so;
      const tableType = this.tableType
    
      let b = this.$message({
        //Message 消息提示
        message: "下载中,请耐心等待....",
        showClose: true,
        duration: 0,
      });
      this.dispatchXcodeFileName(store, {
        project: this.localProject,
        id: data.id,
      }).then((res) => {
        const link = document.createElement("a");
        this.dispatchPerfettoDownLoadDimensionStack(store, {
          project: this.localProject,
          id: data.id,
          old_id: data.old_id,
          func: tableType == "so" ? '' : functionData[data.type][data.id].join(";"),
          so: tableType == "so" ? soData[data.type][data.id].join(";") : '',
          dimension: data.dimensions,
        }).then(htmlContent => {
          // 创建一个 Blob 对象来存储 HTML 内容
          const blob = new Blob([htmlContent], { type: "text/html" });

          // 创建一个指向 Blob 对象的 URL
          const url = URL.createObjectURL(blob);

          // 创建一个临时的 <a> 标签
          const link = document.createElement("a");
          link.href = url; // 设置链接为 Blob URL
          link.download = `${res.filename}${
            tableType == "so" ? "_so" : "_function"
          }.html`; // 设置下载文件的名称
          link.style.display = "none"; // 隐藏 <a> 标签

          // 将 <a> 标签添加到 DOM 中
          document.body.appendChild(link);

          // 触发点击事件以开始下载
          link.click();

          // 从 DOM 中移除 <a> 标签
          document.body.removeChild(link);

          // 释放 Blob URL
          URL.revokeObjectURL(url);
          b.close();
        });
      });
    },
    mergeCells({ row, column, rowIndex, columnIndex }) {
      const rowCount = this.tableData.length

      if (columnIndex === 0) {
        const rowCount = this.tableData.filter(item => item.lastVersion == row.lastVersion).length
        if (rowCount > 1) {
          const isFirstRow = this.tableData.findIndex(item => item.lastVersion == row.lastVersion) === rowIndex
          return isFirstRow ? { rowspan: rowCount, colspan: 1 } : { rowspan: 0, colspan: 0 }
        }
      }

      if (columnIndex === 1 || columnIndex === 2) {
        if (rowIndex === 0) return { rowspan: rowCount, colspan: 1 }
        else return { rowspan: 0, colspan: 0 }
      }

      if (columnIndex === 3 || columnIndex === 4 || columnIndex === 5) {
        const rowCount = this.tableData.filter(
          (item) =>
            item.memory_diff === row.memory_diff && item.diif_new === row.diif_new
        ).length;
        if (rowCount > 1) {
          const isFirstRow =
            this.tableData.findIndex(
              (item) =>
                item.memory_diff === row.memory_diff &&
                item.diif_new === row.diif_new
            ) === rowIndex;
          return isFirstRow
            ? { rowspan: rowCount, colspan: 1 }
            : { rowspan: 0, colspan: 0 };
        }
      }
    },

    risk_color(num) {
      let text = "";
      let color = "";
      if (typeof num == "number") {
        if (num < 0) {
          text = Math.abs(num) + "↓";
        } else {
          text = Math.abs(num) + "↑";
          if (num >= 10 && num <= 30) {
            color = "orange";
          } else if (num < 10) {
            color = "rgb(0, 176, 80)";
          } else if (num > 30) {
            color = "red";
          }
        }
      } else {
        text = num;
      }
      return [text, color];
    },
  }
}
</script>

<style scoped>
.download-link {
  color: #61c3e4;
  text-decoration: underline;
  cursor: pointer;
}
</style>